import { Component } from 'react';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import SakuraSep from './SakuraSep';

class AboutUs extends Component {
    componentDidMount() {
        const $ = window.jQuery;
        if (!$) return;

        if (window.Swiper && document.querySelector('.testimonials-slider')) {
            new window.Swiper('.testimonials-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                pagination: { el: '.swiper-pagination', clickable: true },
                navigation: { nextEl: '.testimonials-container .swiper-button-next' },
            });
        }

        $('.start-counter').each(function () {
            $(this).countTo();
        });
    }

    render() {
        return (
            <>
            <PageMeta title="Giới thiệu" description="Tìm hiểu về lịch sử và tinh thần của Vietnam Yosakoi Festival." url="/about" image="https://vietnamyosakoi.com/images/about-us-background.jpg" />
            <div className="about-us">

                {/* Page Header */}
                <div className="page-header about-pg-header">
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">VỀ CHÚNG TÔI</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                {/* About content */}
                <div className="about-main-content">
                    <div className="container">
                        <div className="entry-title">
                            <p>VỀ CHÚNG TÔI</p>
                            <h2>CÂU CHUYỆN CỦA CHÚNG TÔI</h2>
                        </div>

                        <div className="about-text-cols">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <h3>Mang văn hóa Nhật Bản đến với Việt Nam</h3>
                                    <p>Lễ hội Yosakoi Việt Nam được thành lập với tâm huyết mang vũ điệu Yosakoi cùng văn hóa Nhật Bản đến gần hơn với người dân Việt Nam. Qua từng mùa lễ hội, chúng tôi đã chứng kiến hàng nghìn khán giả hòa mình vào những giai điệu sôi động và những bộ trang phục rực rỡ sắc màu qua nhiều thời kỳ.</p>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <h3>Kết nối trái tim và con người </h3>
                                    <p>Trong suốt hành trình hơn 10 năm, chúng tôi không ngừng nỗ lực xây dựng cầu nối văn hóa Nhật–Việt thông qua vũ điệu Yosakoi. Năm 2026 đánh dấu cột mốc quan trọng với quy mô lớn nhất từ trước đến nay, quy tụ hơn 50 đội tham gia cả từ Việt Nam và Nhật Bản.</p>
                                </div>
                            </div>
                        </div>

                        <figure className="about-cover-image">
                            <img src="images/hihi.jpg" alt="Lễ hội Yosakoi" />
                        </figure>
                    </div>
                </div>

                <SakuraSep />

                {/* Milestones */}
                <div className="about-milestones">
                    <div className="container">
                        <div className="entry-title text-center">
                            <p>CON SỐ BIẾT NÓI</p>
                            <h2>Những Dấu Ấn Nổi Bật</h2>
                        </div>
                        <div className="milestones-grid">
                            {[
                                { to: 390, label: '.',    suffix: '' },
                                { to: 68,  label: '.',   suffix: '' },
                                { to: 120, label: '.',       suffix: 'K' },
                                { to: 8,   label: '.',       suffix: '' },
                                { to: 325, label: '.', suffix: 'K' },
                            ].map(({ to, label, suffix }) => (
                                <div key={label} className="milestone-item">
                                    <div className="milestone-number">
                                        <span className="start-counter" data-to={to} data-speed="2000">0</span>
                                        {suffix && <span className="milestone-suffix">{suffix}</span>}
                                    </div>
                                    <div className="milestone-label">{label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <SakuraSep />

                {/* Testimonials */}
                <div className="testimonial-wrap flex flex-wrap">
                    <div className="testimonials-container">
                        <div className="swiper-container testimonials-slider">
                            <div className="swiper-wrapper">
                                {[
                                    { name: 'Nguyễn Lan Anh',   role: 'Thành viên đội Hanoi Yosakoi',  text: 'Lễ hội Yosakoi đã thay đổi cuộc đời tôi. Tôi không chỉ học được vũ điệu Yosakoi mà còn tìm được những người bạn thực sự và tình yêu với văn hóa Nhật Bản.' },
                                    { name: 'Trần Minh Khải',   role: 'Khán giả trung thành từ 2019', text: 'Mỗi năm tôi đều chờ đợi lễ hội Yosakoi như một ngày hội lớn. Năng lượng của các đội biểu diễn thật sự truyền cảm hứng và đầy màu sắc.' },
                                    { name: 'Phạm Thu Hương',   role: 'Huấn luyện viên đội Sakura HCM', text: 'Chúng tôi đã luyện tập suốt 6 tháng để chuẩn bị cho lễ hội. Khoảnh khắc bước ra sân khấu dưới tiếng hò reo của khán giả là điều tuyệt vời nhất.' },
                                ].map((t, i) => (
                                    <div key={i} className="swiper-slide">
                                        <div className="testimonial-content-wrap flex flex-wrap align-items-stretch">
                                            <figure className="user-avatar">
                                                <img src="images/testimonial-user.jpg" alt={t.name} />
                                            </figure>
                                            <div className="testimonial-content">
                                                <header className="entry-header">
                                                    <h2 className="entry-title">Chúng Tôi Yêu Yosakoi</h2>
                                                </header>
                                                <div className="entry-content">
                                                    <p>"{t.text}"</p>
                                                </div>
                                                <footer className="entry-footer">
                                                    <a href="#">{t.name}, {t.role}</a>
                                                </footer>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="swiper-pagination"></div>
                        </div>
                        <div className="swiper-button-next">
                            <span className="slider-nav-btn">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="9 18 15 12 9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div className="testimonial-featured-image">
                        <img src="images/about/1.jpg" alt="Festival" />
                    </div>
                </div>

                <SakuraSep />

                <div className="sep-gold-rule" style={{margin: 0}} />

            </div>
            </>
        );
    }
}

export default AboutUs;
